export var WidgetType;
(function (WidgetType) {
    WidgetType["Unknown"] = "Unknown";
    WidgetType["RatePlan"] = "RatePlan";
    WidgetType["Cashback"] = "Cashback";
    WidgetType["Button"] = "Button";
    WidgetType["Slider"] = "Slider";
    WidgetType["Comparer"] = "Comparer";
})(WidgetType || (WidgetType = {}));
